import Echo from "laravel-echo";
import Pusher from "pusher-js";

// Configure Laravel Echo with Pusher
window.Pusher = Pusher;

// Pusher.logToConsole = true;

export const echo = new Echo({
  broadcaster: "pusher",
  // key: "23c147e59fa257087587",
  key: "pusher_app_key",
  cluster: "mt1",
  // wsHost: "10.110.10.118",
  // wsPort: 6001,
//   key: process.env.VUE_APP_PUSHER_APP_KEY,
//   cluster: process.env.VUE_APP_PUSHER_APP_CLUSTER,
  encrypted: true,
  forceTLS: false,
});
